import { useEffect, useState } from "react";
import axios from "axios";

export default function UpdateUser() {

const token = localStorage.getItem("token"); 
  //search 
  const [search, setSearch] = useState("");

  //other
  const [users, setUsers] = useState([]);
  const [editingUser, setEditingUser] = useState(null);
  const [msg, setMsg] = useState("");

  const loadUsers = () => {
    axios
      .get(`/api/clients` , {
      headers: {
        Authorization: `Bearer ${token}`
      }
    })
      .then(res => setUsers(res.data))
      .catch(err => console.error(err));
  };

  useEffect(() => {
    loadUsers();
  }, []);

  const handleChange = (e) => {
    setEditingUser({
      ...editingUser,
      [e.target.name]: e.target.value
    });
  };

  const saveUpdate = (e) => {
    e.preventDefault();

    axios.put(
      `/api/clients/${editingUser.klijentID}`,
      editingUser
    , {
      headers: {
        Authorization: `Bearer ${token}`
      }
    })
    .then(() => {
      setMsg("Klijent ažuriran ✅");
      setEditingUser(null);
      loadUsers();
    })
    .catch(() => setMsg("Greška pri update ❌"));
  };


      // Filtrirana lista po search inputu
      const s = search.toLowerCase();

      const filteredUsers = (users || []).filter(u =>
        (u?.ime || "").toLowerCase().includes(s) ||
        String(u?.klijentID || "").includes(search) ||
        (u?.adresa || "").toLowerCase().includes(s) ||
        (u?.email || "").toLowerCase().includes(s) ||
        (u?.grad || "").toLowerCase().includes(s) ||
        (u?.telefon || "").toLowerCase().includes(s)
      );


  return (
    <div className="card bg-dark text-white p-4">
      <h4>Update klijent</h4>

      {/* LOKALNI SEARCH */}
      <input
        type="text"
        className="form-control mb-3 w-25"
        placeholder="Search by ID or name..."
        value={search}
        onChange={(e) => setSearch(e.target.value)}
      />

      {msg && <p>{msg}</p>}

      {/* EDIT FORMA */}
      {editingUser && (
        <form onSubmit={saveUpdate} className="mb-4">

          <label for="ime">Ime</label>
          <input className="form-control mb-2"
            name="ime"
            value={editingUser.ime}
            onChange={handleChange}
            required
          />

          <label for="adresa">Adresa</label>
          <input className="form-control mb-2"
            name="adresa"
            value={editingUser.adresa || ""}
            onChange={handleChange}
          />

          <label for="grad">Grad</label>
          <input className="form-control mb-2"
            name="grad"
            value={editingUser.grad || ""}
            onChange={handleChange}
          />

          <label for="telefon">Telefon</label>
          <input className="form-control mb-2"
            name="telefon"
            value={editingUser.telefon || ""}
            onChange={handleChange}
          />

          <label for="email">Email</label>
          <input className="form-control mb-2"
            name="email"
            value={editingUser.email}
            onChange={handleChange}
            required
          />

          <label for="password">Password</label>
          <input className="form-control mb-3"
            name="password"
            value={editingUser.password}
            onChange={handleChange}
            required
          />

          <label for="uloga">Role</label>
          <input className="form-control mb-3"
            name="uloga"
            value={editingUser.uloga}
            onChange={handleChange}
          />

          <button className="btn btn-success w-100">
            Sačuvaj izmene
          </button>

        </form>
      )}
        
      {/* TABELA */}
      <table className="table table-dark">
        <thead>
          <tr>
            <th>ID</th>
            <th>Ime</th>
            <th>Email</th>
            <th>Telefon</th>
            <th>Grad</th>                        
            <th>Adresa</th>
            <th>Uloga</th>
            <th></th>
          </tr>
        </thead>

        <tbody>
          {filteredUsers.map(u => (
            <tr key={u.klijentID}>
              <td>{u.klijentID}</td>
              <td>{u.ime}</td>
              <td>{u.email}</td>
              <td>{u.telefon}</td>
              <td>{u.grad}</td>
              <td>{u.adresa}</td>
              <td>{u.uloga}</td>
              <td>
                <button
                  className="btn btn-warning btn-sm"
                  onClick={() => setEditingUser(u)}
                >
                  Edit
                </button>
              </td>
            </tr>
          ))}
        </tbody>
      </table>

    </div>
  );
}